<app-datatable
  [dataSourceUrl]="dtDataSourceUrl"
  [settings]="dtSettings"
  [events]="dtEvents"
  (onInit)="onDtInit($event)"
  (onAction)="onAction($event)"
>
  <th class="column-hide" data-data="id">Azonosító</th>
  <th data-data="registrationNumber" title="Nyilvántartási szám">Nyilv. szám</th>
  <th data-data="fullName">Név</th>
  <th data-data="citizenship" title="Állampolgárság">Államp.</th>
  <th data-data="mothersName">Anyja neve</th>
  <th data-data="birthPlace" title="Születési helye">Szül. helye</th>
  <th class="date" data-data="birthDate" title="Születési ideje">Szül. ideje</th>
  <th data-data="language">Vizsgázó nyelve</th>
  <th data-data="email">E-mail címe</th>
  <th data-data="computerNumber">Vizsga gép</th>
  <th class="column-actions">Műveletek</th>
</app-datatable>
<router-outlet></router-outlet>
